/* --------------------------------------------------------------------------------------
   testResults.component.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const testResultsComponent = {
  template: require('./testResults.html'),
  controller: 'testResultsCtrl',
  controllerAs: 'vm',
  bindings: {
    back: '&',
    next: '&'
  }
}

export class testResultsCtrl {
  /*@ngInject*/
  constructor(commonService, dataService, appService, $state, $scope) {
    this.commonService = commonService
    this.dataService = dataService
    this.appService = appService
    this.working = true
    this.disableEmail = false
    this.$state = $state
    this.$scope = $scope
  }
  $onInit() {
    this.commonService.setDefaultBackground()
    this.className = this.appService.className
    this.testName = this.appService.testName

    this.dataService.GetResults(this.appService.classId, this.appService.testId)
      .then(result => this.setItems(result))
      .then(() => this.setXrxResultsTable())
      .catch(error => {
        this.appService.handleError(error)
          .then(result => {this.error = result})
      })
  }
  emailStudents() {
    this.sending = true
    this.dataService.GetEmailStudents(this.appService.classId, this.appService.testId)
      .then(result => {
        this.sending = false
        angular.element('#emails-sent-banner').xrxbanner("call");
        angular.element('#sent-activity').xrxactivityindicator("complete");
      })
  }

  setItems(items) {
    if (items.HasTestResults) {
      if (items.HasSomeEmailAddresses) {
        $('#emailstudents').xrxbutton({ disabled: false })
        this.disableEmail = false;
      } else {
        $('#emailstudents').xrxbutton({ disabled: true })
        this.disablebuttons = true;
      }
      $('#runreports').xrxbutton({ disabled: false })
    } else {
      $('#emailstudents').xrxbutton({ disabled: true })
      this.disableEmail = true
      $('#runreports').xrxbutton({ disabled: true })
    }

    this.totaltests = items.TotalTests;
    this.totalstudents = items.TotalStudents;

    this.items = items.Respondents
    this.working = false
    return Promise.resolve()
  }
  setXrxResultsTable() {
    var screenHeight = $.screenHeight();

    $('#results-table').xrxtable({
      theme: 'navy',
      bordered: true,
      widgetSize: 'xrx-small',
      scroll: true,
      height: (screenHeight > 481) ? '413' : '285',
      readonly: true
    })
  }
  done() {
    this.$state.go('main')
  }
  errorClosed() {
    return this.appService.errorClosed(this.error)
  }
}



// WEBPACK FOOTER //
// ./src/app/common/components/testResults.component.js